import Api from '@/services/api/plataformas/api/index.js';
import Cdn from '@/services/api/plataformas/api/cdn.js';
import endpoints from './endpoint';

/**
 * Defaults to the playable set, completed MP4s, ordered by class then start time.
 * The `take` max value (2000) is used explicitly, the api defaults to 50 (no pagination needed).
 */
const list = (args) => {
  const params = new URLSearchParams();

  params.append('calendario_id', args.calendario_id);
  params.append('take', '2000');

  return Api.get(`${endpoints.get('list')}?${params.toString()}`);
};

/**
 * Mints the cookie set for one recording. Useful output is the `Set-Cookie` rather than the body.
 * The response carries the `playback_url` those cookies authorise.
 */
const access = (args) => {
  const params = new URLSearchParams();

  params.append('recording_id', args.recording_id);

  return Cdn.post(`${endpoints.get('access')}?${params.toString()}`);
};

export default {
  list,
  access,
};
